import React from 'react';
import { FormikProps } from 'formik';
import { CalendarTodayRounded } from '@material-ui/icons';
import { FormikTextField } from '../../../shared/Formik/FormikTextField';
import { FormikDateField } from '../../../shared/Formik/FormikDateFIeld';
import { useAuth } from '../../../context/auth';
import { BannerWrapper } from '../../CreateCampign.styles';
import { Label, StyledField } from '../../CreateCampign.styles';
import { Wrapper, DovePointsInfo } from './Duration.styles';

export const Duration = (props: FormikProps<any>) => {
  const { user, wallet } = useAuth();
  return (
    <>
      <Label>Start Date</Label>
      <StyledField 
        name="duration.startDate"
        variant="outlined"
        minDate={new Date()}
        decoratorEnd={<CalendarTodayRounded color='disabled' />}
        component={FormikDateField}
      />
      <Wrapper>
        <div>
          <Label>Scheduled End Date</Label>
          <StyledField 
            name="duration.scheduleEndDate"
            variant="outlined"
            minDate={props.values.duration.startDate || new Date()}
            decoratorEnd={<CalendarTodayRounded color='disabled' />}
            component={FormikDateField}
          />
        </div>
        <div>
          <Label>DovePoints Limit</Label>
          <StyledField
            name="duration.dovepointsLimit"
            variant="outlined"
            type="number"
            component={FormikTextField}
          />
          {(wallet && user && !user.isAdmin) &&
            <DovePointsInfo>DovePoints Available: {wallet.availablePoints}</DovePointsInfo>
          }
        </div>
      </Wrapper>
      <BannerWrapper>
        Select End Date or DoveScore Limit to decide on campaign duration. In case of selecting both, campaign will end when first of them is reached.
      </BannerWrapper>
    </>
  )
};
